export const updateEventTargetValue = (event, id, value) => {
  // destroy event target in order to override value attr with value
  // TODO investigate and find better solution
  event.target = { ...event.currentTarget, id, value };

  return { ...event };
};
